import { FileUploadFile } from 'primereact/fileupload';
import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { uploadFileAndRetrieveFileUrl } from '../../../../../api/operations/files/upload-file-and-retrieve-file-url';
import globalUserProfile from '../../../../../stores/global-user-profile';

export const studentAssignmentUploadOperation = async (
  programId: number,
  courseId: number,
  assignmentId: number,
  file: FileUploadFile | undefined,
  hideDialog: () => void,
  setLoading: (loading: boolean) => any,
) => {
  try {
    const studentId = globalUserProfile.userProfile.userWithRole.id;

    if (!studentId) {
      toast.warn('לא ניתן לאתר את מזהה הסטודנט, נסה שוב בעוד מספר רגעים...');
      return;
    }

    if (!file) {
      toast.warn('תחילה יש להעלות קובץ');
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (!fileExtension?.length) {
      toast.warn(
        'לא ניתן לאתר את סוג הקובץ, נסה להוסיף סיומת לקובץ והעלאה מחדש',
      );
      return;
    }

    setLoading(true);

    const preSignUrlRes = await appApi.getAssignmentStudentPreSignUrl(
      programId,
      courseId,
      assignmentId,
      studentId,
      fileExtension,
    );

    const fullUrl = await uploadFileAndRetrieveFileUrl(
      preSignUrlRes.data.body,
      file,
    );

    if (!fullUrl) {
      throw new Error('Can not find uploaded path');
    }

    await appApi.assignmentStudentFileUploadedNotifyBackend(
      programId,
      courseId,
      assignmentId,
      studentId,
      fullUrl,
      file.name,
    );

    // Refresh the user profile to get updated assignment data
    await globalUserProfile.getUserProfile();
    setLoading(false);
    hideDialog();
    toast.success('הקובץ הועלה בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('העלאת קובץ נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `studentAssignmentUploadOperation failed with programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId}, fileName: ${file?.name}, error: ${e}`,
    );
  }
};
